const createElementCanvas = (nameElementCanvas, idElement) => {
  var charContainer = document.getElementById(idElement);
  var ctx = document.createElement("canvas");
  ctx.id = nameElementCanvas;
  charContainer.appendChild(ctx);
  return ctx;
};
export default createElementCanvas;
